export default __webpack_public_path__ + "static/media/Arm-bands of the Hell Walker (nm).45278e59.jpg";